"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateParams = validateParams;
function validateParams(params) {
    for (let key in params) {
        if (typeof params[key] === "undefined" ||
            params[key] === null ||
            params[key] === "" ||
            params[key] === undefined) {
            if (key === "userId" || key === "token") {
                throw new Error("Invalid action. Please set user or login again");
            }
            if (key === "apiSecret") {
                throw new Error("Invalid action. Please set apiSecret in the base(QuestSdk) class");
            }
            throw new Error(`Invalid ${key}`);
        }
    }
}
